import React from 'react';

function TrashSVG() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.8002 10.0002C7.8002 9.55837 7.44202 9.2002 7.0002 9.2002C6.55837 9.2002 6.2002 9.55837 6.2002 10.0002V14.0002C6.2002 14.442 6.55837 14.8002 7.0002 14.8002C7.44202 14.8002 7.8002 14.442 7.8002 14.0002V10.0002Z" />
      <path d="M13.0002 9.2002C13.442 9.2002 13.8002 9.55837 13.8002 10.0002V14.0002C13.8002 14.442 13.442 14.8002 13.0002 14.8002C12.5584 14.8002 12.2002 14.442 12.2002 14.0002V10.0002C12.2002 9.55837 12.5584 9.2002 13.0002 9.2002Z" />
      <path d="M10.8002 8.5002C10.8002 8.05837 10.442 7.7002 10.0002 7.7002C9.55837 7.7002 9.2002 8.05837 9.2002 8.5002V15.5002C9.2002 15.942 9.55837 16.3002 10.0002 16.3002C10.442 16.3002 10.8002 15.942 10.8002 15.5002V8.5002Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 4H15V3C15 1.34315 13.6569 0 12 0H8C6.34315 0 5 1.34315 5 3V4H1C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6H2V17C2 18.6569 3.34315 20 5 20H15C16.6569 20 18 18.6569 18 17V6H19C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4ZM7 3C7 2.44772 7.44772 2 8 2H12C12.5523 2 13 2.44772 13 3V4H7V3ZM4 17V6H16V17C16 17.5523 15.5523 18 15 18H5C4.44772 18 4 17.5523 4 17Z"
      />
    </svg>
  );
}

export default TrashSVG;
